import { Component } from '@angular/core';

@Component({
    selector: 'registration-confirmation',
    templateUrl: './registration_confirmation.component.html',
    styleUrls: ['./registration_confirmation.component.scss'],
})
export class RegistrationConfirmationComponent {}
